import { SupportedMarketKey } from '@nxt-insurance/constants'

import { getContentsFlowConfig } from '@/app/utils/flows/contentsFlowConfig'
import { createFlowServerSideProps } from '@/app/utils/flows/createFlowServerSideProps'
import { createFlowStepPage } from '@/shared/components/flows/FlowStepPage'
import { trpc } from '@/utils/trpc'
import { ContentsInstantQuoteQuestions, UnderInsuredWarning } from '@flows-ui/stepRenderer'

export const CONTENTS_FLOW = 'contents'

const ContentsStep = createFlowStepPage({
  flowName: CONTENTS_FLOW,
  productKey: 'contents_v1_getsafe_de',
  quoteStepName: 'contents_quote',
  i18nNamespace: 'sharedFlows_contentsNxt',
  router: trpc.contentsFlow,
  useUtils: () => trpc.useUtils().contentsFlow,
  getConfig: getContentsFlowConfig,
  extraComponents: () => ({
    ContentsInstantQuoteQuestions,
    UnderInsuredWarning,
    ConfirmLocation: () => null,
  }),
})

export const getServerSideProps = createFlowServerSideProps({
  flowNamePath: CONTENTS_FLOW,
  market: SupportedMarketKey.De,
  translationNamespace: 'sharedFlows_contentsNxt',
  getConfig: getContentsFlowConfig,
})

export default ContentsStep
